<template>

   <spinner v-if="!loaded" ></spinner>

    <div class="template-padding container" v-else-if="loaded"  > 
        
        <div class="row" >
            <div class="col-12 text-left" >
                <router-link :to="{name: 'Facebook Ads Masterclass' }" class="not-active text-left btn btn-transparent border-none btn-sm" > 
                    <font-awesome-icon icon="arrow-circle-left" ></font-awesome-icon> Back 
                </router-link>
            </div>
        </div>
        
        <div class="col-12 col-md-10 offset-md-1 p-0 mt-3" >
            <img src="@/assets/images/facebook_ads_masterclass_1200x628-01.png" class="w-100" />
        </div>
        
        <div class="text-justify mt-5 mb-3 h3" style="line-height: 1.5;" >

        </div>
        
        <!-- ACADEMY -->
        <div class="accordion mt-5" role="tablist">
            
            <!-- INTRO -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-0 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        The money is in the numbers
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion0" > {{ calculateRead('accordion0') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-0"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion0" >
                        
Without understanding the data, you’re trying to run the business blind, you’re guessing. This is why data and tracking can MAKE or BREAK your business.
<br><br>
Running an online business is a constant optimization process. 
<br><br>
Oftentimes overlooked, understanding the key data points can be the difference between a struggling and a thriving online business. In order to understand these metrics, we first need to talk about tracking.
<br><br>
Tracking is the most important part of running an online business successfully. Unfortunately, many people don’t realise how important tracking is.

                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- INTRO -->
            
            <!-- Structure -->
            <!--
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-1 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        Title
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion1" > {{ calculateRead('accordion1') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-1"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion1">
                        
                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            -->
            <!-- Structure -->
                    
            <!-- Structure -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-2 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        Metrics for your ads
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion2" > {{ calculateRead('accordion2') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-2"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion2">
                        
<br><h2 class="font-size-16 font-weight-bold" >CPC – Cost Per Click</h2>
This shows how much you pay for every click on the ad and it’s calculated by dividing the total money spent on ads by the number of clicks.
<br><br>
<br><h2 class="font-size-16 font-weight-bold" >CTR – Click Through Rate</h2>
This shows what % of people are clicking through the ad to get to the sales page.
<br><br>
<br><h2 class="font-size-16 font-weight-bold" >CPL – Cost Per Lead</h2>
This shows you how much every lead that opts-in costs you.
<br><br>
<br><h2 class="font-size-16 font-weight-bold" >CVR – Conversion Rate</h2>
This shows what % of people bought the product or service you are offering
<br><br>
<br><h2 class="font-size-16 font-weight-bold" >CPA – Cost Per Acquisition ( Cost Per Sale )</h2>
This shows how much it costs you to get a sale and it’s calculated by dividing the total money spent on ads by the number of sales.
<br><br>
<br><h2 class="font-size-16 font-weight-bold" >CV – Conversion Value</h2>
This shows the amount of revenue that was generated.
<br><br>
<br><h2 class="font-size-16 font-weight-bold" >ROAS – Return On Ad Spend</h2>
This shows how much you get back after spending on ads and tells you if your ads are profitable or not.
<br><br>
Let’s look at an example:<br>
Say you are paying $50 for an ad and that ad has 1000 impressions, meaning 1000 people saw it. Out of 1000 people, 50 clicked your ad. 
<br><br>
This means you have  a CTR of 5%.
<br><br>
If your total spend was $50 and you’ve got 50 clicks, that means your CPC is $1.
<br><br>
Now, if out of those 50 people, 10 people opt in and 5 of them bought your product, you’ve got a CVR of 10%. Based on that, we can easily calculate the CPA is $10 ( $50/5) as well as the CPL, which is $5 ( $50/10 leads ).
<br><br>
Now, let’s look at the value of those sales. Say for example, your offer is $50 for every product or service bought.
<br><br>
So your Total Conversion Value is $250, 5 sales of $50 each. Based on that, we can easily calculate the ROAS: $200. Cause you spent $50 to get $200, which is a pretty good investment.
<br><br>
Now this is a simple example, to better understand these metrics. In real life, it’s not gonna be that pretty.
<br><br>
When you have all the data at your disposal, you can then look for weaknesses and try to optimise them.

                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Structure -->
                    
            <!-- Structure -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-3 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        Understanding Tracking
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion3" > {{ calculateRead('accordion3') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-3"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion3">
                        
<br><h2 class="font-size-16 font-weight-bold" >What are URL parameters?</h2>

There are 4 key components that form a URL: the scheme ( https ), a host ( the domain ), a path ( /category/product ) and a query string.
<br><br>
We are going to focus on the last one. A query string is a serie of parameters used to track information on a website ( campaing=my-first-campaing ). These parameters are separated from the base of the link with the question mark ( ? )
<br><br>
A valid URL link can only have one single question mark ( ? )
The URL parameters are formed out of pairs of key and value, connected with the = sign, for example campaign=my-first-campaign, where the campaign is the key and my-first-campaign is the value.
<br><br>
Multiple pairs can be added, connected with the and sign ( & ): campaing=my-first-campaign&ad=myfirst-ad
<br><br>
UTM stands for Urchin Traffic Monitor and were created by a web analyst that worked on the Google Analytics project.
<br><br>
There are five different UTM parameters. The first 3 are by far the most used parameters (Source, Medium, Campaign), but for additional insights you may also choose to track all 5. Here’s exactly what you can track with each:
<br><br>
<br><h2 class="font-size-16 font-weight-bold" >1. Traffic Source</h2>
The utm_source parameter allows you to track where the traffic originated from: facebook, google, bing, inbound.org, or the name of an email list.
<br><br>
Example: &utm_source=instagram
<br><br>
<br><h2 class="font-size-16 font-weight-bold" >2. Medium</h2>
The utm_medium parameter tracks what type of traffic the visitor originated from: cpc, email, social, referral, display, etc.
<br><br>
Example: &utm_medium=cpc
<br><br>
<br><h2 class="font-size-16 font-weight-bold" >3. Campaign Name</h2>
The utm_campaign parameter allows you to track the traffic by campaign name.
<br><br>
Example: &utm_campaign=example-campaign
<br><br>
<br><h2 class="font-size-16 font-weight-bold" >4. Content</h2>
The utm_content parameters allow you to segment the traffic, for example when doing A/B tests.
<br><br>
Example: &utm_content=navlink
<br><br>
<br><h2 class="font-size-16 font-weight-bold" >5. Keyword Term</h2>
The utm_term parameter allows you to track which paid keyword term a website visitor came from.
<br><br>
Example: &utm_term=scale-business-hack
<br><br>
<br><h2 class="font-size-16 font-weight-bold" >How to Use the UTM parameters</h2>
You can use these codes in any combination as long as you separate each parameter with the ‘&’ sign, as we spoke above.
<br><br>
<br><h2 class="font-size-16 font-weight-bold" >How to create UTM parameters ?</h2>
You can create UTM parameters manually, by adding the key=value pairs and separate them with ‘&’ sign.
<br><br>
You can also use the Google URL Builder from here
<br><br>
<br><h2 class="font-size-16 font-weight-bold" >How to track UTM parameters?</h2>
You can track a particular URL parameter using the watcher from your Atlass account.
<br><br>
Atlass also tracks each parameter individually and you can group the traffic based off of them in the Analyze and Engagement section.

                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Structure -->
            
            <!-- Structure -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-4 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        Supercharge your tracking with Atlass
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion4" > {{ calculateRead('accordion4') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-4"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion4">
                        
Atlass allows you to accurately track and attribute sales to the correct ad that will help you find the winners and increase ROAS.
<br><br>
With the latest IOS updates, browser shields and other ad blockers, ad tracking has never been worse and a lot of advertisers are complaining that ad manager reporting is off.
<br><br>
Missing clicks, unattributed sales and wrong conversion value can give you the wrong idea when optimizing and improving your ads.
<br><br>
<br><h2 class="font-size-16 font-weight-bold" >So how does Atlass work</h2>
You plug it into your business via our dedicated integration and our algorithm will do the rest for you.
<br><br>
<br><h2 class="font-size-16 font-weight-bold" >Effectively Track all your ads and campaigns</h2>
Facebook ads, Google Ads, TikTok Ads, Email campaigns, referral and affiliate marketing , everything. 
<br><br>
Our attribution algorithm will consider all touchpoints, regardless of the ad platform so you have 100% clarity, transparency and accuracy.
<br><br>
<br><h2 class="font-size-16 font-weight-bold" >Attribute sales to the Correct Ad</h2>
Ad tracking has never been worse. Having all touchpoints allows us to accurately attribute the sales to the correct ad.
<br><br>
Fix your tracking and attribute sales to the correct ad. Don't rely solely on Facebook and Google pixel, get better reporting in order to make data-driven decisions.
<br><br>
<br><h2 class="font-size-16 font-weight-bold" >Analyze Customer Journey</h2>
Have full transparency of your data. Analyze customer journey and click history.
<br><br>
We unify your customer’s touch points from across all platforms and channels into a single view.
<br><br>
<br><h2 class="font-size-16 font-weight-bold" >Easily analyze campaign performance from all ad managers</h2>
Save time by accessing all the data and metrics you need under one roof.
<br><br>
Analyze ad and campaign perfomance from Facebook, Google and Tiktok ad managers in one single dashboard and get an overview of all your ad spent.
<br><br>
<br><h2 class="font-size-16 font-weight-bold" >Scale Winner Ads and Cut out the Losers</h2>
Know exactly how much your ads are making and scale what's working while turning off what isn't.
<br><br>
Take control of your budget and increase your Ad ROAS.
<br><br>
<br><h2 class="font-size-16 font-weight-bold" >Improve Key Metrics to Grow Your Business</h2>
Do more with your data. Analyze key metrics and increase your AOV and revenue using modern-day strategies and back-end offers.
<br><br>
Scale your business by increasing LTV and decreasing churn rate.
<br><br>
Book a free strategy call with our team now to get started.
<br><br>
Oftentimes overlooked, tracking is the most important part of scaling. Without tracking and data, you are literally running blindfolded.

                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Structure -->
        
          </div>
        <!-- ACADEMY -->

        
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
    
export default{
    name: "ACADEMY_sales_page",
    props:["APPKEY"],
    components:{
    },
    data () {
        return {
            loaded: false,
            text: `
              Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
              richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
              brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
              tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
              assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
              wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
              vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
              synth nesciunt you probably haven't heard of them accusamus labore VHS.
            `
        }
    },
    mounted(){
        this.loaded = true;
    },
    methods:{
        openRow(params){
            
            let user =  Cookies.get('user')
            user = JSON.parse( atob( user ) )
            
            let page = params.row.Icon;
            let ID = params.row.ID;
            
            
            
            
        },
        returnDate(a){
            //return this.$moment.unix(a).format( 'MMM D, HH:mm' )
            return helper.formatDate( a, 'MMM D, HH:mm' )
        },
        
        calculateRead( target ){
            
            //console.log( ev )
            setTimeout( function(){
                
                //console.log( this.$refs )
                //console.log( this.$refs[target].innerHTML )                
                
                let ev = this.$refs[target].innerHTML
                
                const wordsPerMinute = 150; // Average case.
                let result;
                
                let textLength = ev.split(" ").length; // Split by words
                if(textLength > 0){
                    let value = Math.ceil(textLength / wordsPerMinute);
                    result = `~${value} min read`;
                }
                //return result
                //this.$refs[target].appendChild( result )
                document.getElementById(target).innerHTML = result;
                
            }.bind(this), 400 )
                
        }
    },
    computed: {

    },
    created: function () {

    },
    
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/templates/Academy/courses/facebook-ads-masterclass/05.vue